import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as clevertapFresh from 'clevertap/fresh';
import * as actFresh from 'actions/fresh';
import { MOKA_FRESH_HOST } from 'api/constants';
import PhaseOut from './PhaseOut';

class Fresh extends Component {
  componentDidMount() {
    this.props.dispatch(actFresh.pageRequest());
  }

  render() {
    const { isEligible } = this.props;
    return <PhaseOut isEligible={isEligible} />;
  }

  _handleSubmit = value => {
    const { isEligible, form } = value;
    if (isEligible) {
      clevertapFresh.startShopping();
      window.location.href = MOKA_FRESH_HOST;
    } else {
      this.props.dispatch(actFresh.submitQuestion(form));
    }
  };
}

const mapStateToProps = state => ({
  showLoadingSpinnerPage: state.loadingSpinner.showLoadingSpinnerPage,
  isEligible: state.fresh.isEligible,
});

export default connect(mapStateToProps)(Fresh);
